import React from 'react';
import Card from '../Card';
import { ErrorInfo } from '../../../utils/errorHandler';
import WarningCircleIcon from '../../../assets/icons/WarningCircle.svg';
import ClockCircleIcon from '../../../assets/icons/ClockCircle.svg';
import './ErrorDisplay.scss';

// Hourglass icon is in public folder, reference from root
const HourglassIcon = '/icons/Hourglass.png';

interface ErrorDisplayProps {
  errorInfo: ErrorInfo;
  style?: React.CSSProperties;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ errorInfo, style }) => {
  const getErrorIcon = (iconName: string) => {
    switch (iconName) {
      case 'Hourglass':
        return HourglassIcon;
      case 'ClockCircle':
        return ClockCircleIcon;
      case 'WarningCircle':
      default:
        return WarningCircleIcon;
    }
  };

  return (
    <Card
      backgroundColor='#FFFFFF'
      padding='40px 80px'
      style={{ maxWidth: 'calc(100% - 16px)', ...style }}
    >
      <div className='error-display-container'>
        <img 
          src={getErrorIcon(errorInfo.icon)} 
          alt={errorInfo.type} 
          width={70} 
          height={70} 
          className='error-icon'
        />
        <h3 className='error-title'>{errorInfo.title}</h3>
        <p className='error-message'>{errorInfo.message}</p>
      </div>
    </Card>
  );
};

export default ErrorDisplay;

